var map = {
	"./AddBold.svg": 82035,
	"./AddTaskOutlined.svg": 19123,
	"./ApprovalsApp32Filled.svg": 47855,
	"./BookmarkOutline.svg": 25585,
	"./CaretDownOutline.svg": 53692,
	"./Check.svg": 15239,
	"./CloudSatelliteConfig.svg": 62033,
	"./Cube.svg": 11786,
	"./CubeDash.svg": 27730,
	"./CubeLine.svg": 79460,
	"./CubeRotate.svg": 93799,
	"./DataRef.svg": 16956,
	"./Delete24Filled.svg": 77886,
	"./DynCoffee.svg": 10998,
	"./DynDocumentCode.svg": 68110,
	"./DynEdit.svg": 75174,
	"./DynFileDocumentPlus.svg": 59123,
	"./DynTextBoxMultiple.svg": 47802,
	"./Edit.svg": 82869,
	"./FileUpload.svg": 14220,
	"./ForceSave.svg": 64449,
	"./FullscreenExitOutlined.svg": 63112,
	"./FullscreenOutlined.svg": 30896,
	"./GitPullRequestDraft.svg": 93998,
	"./HistoryEduFilled.svg": 7241,
	"./ManageSearchFilled.svg": 69704,
	"./PostAddRound.svg": 32684,
	"./QuickEdit.svg": 15022,
	"./Save.svg": 84850,
	"./SmallLoading.svg": 82698,
	"./SmallLoading2.svg": 1908,
	"./Terminal.svg": 20805,
	"./WindowArrowUp24Filled.svg": 17585,
	"./XMark.svg": 49452
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30279;